var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-data-table',{staticClass:"elevation-1",attrs:{"caption":_vm.caption,"calculate-widths":true,"headers":_vm.datatable.headers,"items":_vm.datatable.data,"search":_vm.search,"items-per-page":_vm.datatable_page_limit}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }